import React from 'react';
import Page from '../../layout/Page';
import PlateReadAwards from './PlateReadAwards';
import { AutoAwards } from '../settings/LPRSettings';

const LicensePlateAwards = () => (
    <Page title='License Plate' icon='award' tabs>
        <PlateReadAwards tab='Awards' />
        <AutoAwards tab='Auto Awards' />
    </Page>
);

export default LicensePlateAwards;